// Resources page entry point

import { initSwiperResourcesWithResize } from './swiper-resources.js';

// ─── Swipers ──────────────────────────────────────────────────────────────────

initSwiperResourcesWithResize();
